import "./App.css";
import "@swisscom/sdx/dist/css/sdx.css";
import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import i18n from "../i18n";
import { useTranslation, Trans } from "react-i18next";

export default function TechnicalDetails() {
  const { t } = useTranslation(["technicalDetails", "common"]);

  useEffect(() => {
    document.title = t("tecdet") + " | Postmaster | Bluewin";
  }, []);

  return (
    <div className="container">
      <div className="row">
        <div className="cortana-side-nav col-md-4 col-lg-3 hidden-phone-down">
          <div className="margin-v-4 sticky">
            <h2 className="sc-navy">{t("common:content")}</h2>
            <ul className="list">
              <ul>
                <li>
                  <Link to="#outbound-ip-addresses" onClick={scrollToOut}>
                    {t("content1")}
                  </Link>
                </li>
                <li>
                  <Link to="#error-codes" onClick={scrollToError}>
                    {t("content2")}
                  </Link>
                </li>
              </ul>
            </ul>
          </div>
        </div>
        <div className="col-xs-12 col-md-8 col-lg-9">
          <h1 className="sc-navy margin-v-4">{t("tecdet")}</h1>
          <h2 id="outbound-ip-addresses" className="sc-navy">
            {t("ip")}
          </h2>

          <ul className="list">
            <li>193.247.246.0/24</li>
            <li>138.188.174.0/24</li>
            <li>138.188.175.0/24</li>
          </ul>

          <h2 id="error-codes" className="sc-navy">
            {t("content2")}
          </h2>

          <div className="table-generic">
            <div className="table__wrapper">
              <div className="row">
                <div className="col-xs-4 col-md-1">
                  <strong>ID</strong>
                </div>
                <div className="col-xs-4 col-md-1">
                  <strong>Code</strong>
                </div>
                <div className="col-xs-36 col-md-6">
                  <strong>{t("desc")}</strong>
                </div>
              </div>
              <div className="border-horizontal"></div>
              <div className="row">
                <div className="col-xs-4 col-md-1">sc141 sc144</div>
                <div className="col-xs-4 col-md-1">550</div>
                <div className="col-xs-36 col-md-6">{t("par1")}</div>
              </div>
              <div className="border-horizontal"></div>
              <div className="row">
                <div className="col-xs-4 col-md-1">sc142 sc146 sc147 sc148</div>
                <div className="col-xs-4 col-md-1">542<br/>550</div>
                <div className="col-xs-36 col-md-6">{t("par2")}</div>
              </div>
              <div className="border-horizontal"></div>
              <div className="row">
                <div className="col-xs-4 col-md-1">sc143</div>
                <div className="col-xs-4 col-md-1">550</div>
                <div className="col-xs-36 col-md-6">{t("par3")}</div>
              </div>
              <div className="border-horizontal"></div>
              <div className="row">
                <div className="col-xs-4 col-md-1">sc208 sc209</div>
                <div className="col-xs-4 col-md-1">550<br/>554</div>
                <div className="col-xs-36 col-md-6">
                  <Trans i18nKey="par4" t={t}>
                    You have been blocked by an external blocklist - <AbusixLink/>
                  </Trans>
                </div>
              </div>
              <div className="border-horizontal"></div>
              <div className="row">
                <div className="col-xs-4 col-md-1">
                  sc303 sc304
                </div>
                <div className="col-xs-4 col-md-1">452</div>
                <div className="col-xs-36 col-md-6">
                  <Trans i18nKey="par5" t={t}>
                    Your sending has been temporarily blocked due to large amount
                    of recipients. If this is incorrect, please contact your mail
                    service provider&apos;s support. If you manage your own sending,
                    use our <ContactFormLink/> for assistance.
                  </Trans>
                </div>
              </div>
              <div className="border-horizontal"></div>
              <div className="row">
                <div className="col-xs-4 col-md-1">sc401 sc402</div>
                <div className="col-xs-4 col-md-1">452</div>
                <div className="col-xs-36 col-md-6">{t("par6")}</div>
              </div>
              <div className="border-horizontal"></div>
              <div className="row">
                <div className="col-xs-4 col-md-1">sc403</div>
                <div className="col-xs-4 col-md-1">421</div>
                <div className="col-xs-36 col-md-6">{t("par7")}</div>
              </div>
              <div className="border-horizontal"></div>
              <div className="row">
                <div className="col-xs-4 col-md-1">sc601</div>
                <div className="col-xs-4 col-md-1">550</div>
                <div className="col-xs-36 col-md-6">{t("par8")}</div>
              </div>
              <div className="border-horizontal"></div>
              <div className="row">
                <div className="col-xs-4 col-md-1">sc603</div>
                <div className="col-xs-4 col-md-1">451</div>
                <div className="col-xs-36 col-md-6">
                  <Trans i18nKey="par9" t={t}>
                    Your sending has been temporarily blocked due to incorrect
                    sender validation. If you believe this is incorrect, please
                    contact your mail service provider&apos;s support. If you manage
                    your own sending, use our <ContactFormLink/> for assistance.
                  </Trans>
                </div>
              </div>
              <div className="border-horizontal"></div>
              <div className="row">
                <div className="col-xs-4 col-md-1">sc771 sc772</div>
                <div className="col-xs-4 col-md-1">421<br/>451<br/>452</div>
                <div className="col-xs-36 col-md-6">{t("par10")}</div>
              </div>
              <div className="border-horizontal"></div>
              <div className="row">
                <div className="col-xs-4 col-md-1">sc710 sc773 sc775</div>
                <div className="col-xs-4 col-md-1">421<br/>451<br/>452</div>
                <div className="col-xs-36 col-md-6">
                  <Trans i18nKey="par11" t={t}>
                    Your sending has been temporarily blocked due to unusual
                    activity that suggests spam. If this is incorrect, please
                    contact your mail service provider&apos;s support. If you manage
                    your own sending, use our <ContactFormLink/> for assistance.
                  </Trans>
                </div>
              </div>
              <div className="border-horizontal"></div>
              <div className="row">
                <div className="col-xs-4 col-md-1">sc821</div>
                <div className="col-xs-4 col-md-1">554</div>
                <div className="col-xs-36 col-md-6">{t("par12")}</div>
              </div>
              <div className="border-horizontal"></div>
              <div className="row">
                <div className="col-xs-4 col-md-1">sc822</div>
                <div className="col-xs-4 col-md-1">421</div>
                <div className="col-xs-36 col-md-6">{t("par13")}</div>
              </div>
              <div className="border-horizontal"></div>
              <div className="row">
                <div className="col-xs-4 col-md-1">sc823</div>
                <div className="col-xs-4 col-md-1">554</div>
                <div className="col-xs-36 col-md-6">{t("par14")}</div>
              </div>
              <div className="border-horizontal"></div>
              <div className="row">
                <div className="col-xs-4 col-md-1">sc981 sc961</div>
                <div className="col-xs-4 col-md-1">554</div>
                <div className="col-xs-36 col-md-6">
                  <Trans i18nKey="par15" t={t}>
                    Your E-mail was rejected based on attributes associated with
                    the sending domain and its context. If this is incorrect,
                    please contact our support via the <ContactFormLink/>.
                  </Trans>
                </div>
              </div>
              <div className="border-horizontal"></div>
              <div className="row">
                <div className="col-xs-4 col-md-1">sc978</div>
                <div className="col-xs-4 col-md-1">554</div>
                <div className="col-xs-36 col-md-6">
                  <Trans i18nKey="par16" t={t}>
                    Your E-Mail was rejected based on your sending IP&apos;s history.
                    If this is incorrect, please contact our support via the <ContactFormLink/>.
                  </Trans>
                </div>
              </div>
              <div className="border-horizontal"></div>
              <div className="row">
                <div className="col-xs-4 col-md-1">sc974</div>
                <div className="col-xs-4 col-md-1">554</div>
                <div className="col-xs-36 col-md-6">
                  <Trans i18nKey="par17" t={t}>
                    Your email was rejected due to an action by our content
                    filtering engine. If this is incorrect, please contact
                    our support via the <ContactFormLink/>.
                  </Trans>
                </div>
              </div>
              <div className="border-horizontal"></div>
              <div className="row">
                <div className="col-xs-4 col-md-1">sc962</div>
                <div className="col-xs-4 col-md-1">554</div>
                <div className="col-xs-36 col-md-6">
                  <Trans i18nKey="par18" t={t}>
                    You have been blocked by an external blocklist - <CloudMarkLink/>
                  </Trans>
                </div>
            </div>
            <div className="border-horizontal"></div>
            <div className="row">
              <div className="col-xs-4 col-md-1">sc963 sc973</div>
              <div className="col-xs-4 col-md-1">451</div>
              <div className="col-xs-36 col-md-6">{t("par19")}</div>
            </div>
            <div className="border-horizontal"></div>
              <div className="row">
                <div className="col-xs-4 col-md-1">sc987</div>
                <div className="col-xs-4 col-md-1">554</div>
                <div className="col-xs-36 col-md-6">{t("par20")}</div>
              </div>
              <div className="border-horizontal"></div>
              <div className="row">
                <div className="col-xs-4 col-md-1">sc923 sc988</div>
                <div className="col-xs-4 col-md-1">554</div>
                <div className="col-xs-36 col-md-6">{t("par21")}</div>
              </div>
              <div className="border-horizontal"></div>
              <div className="row">
                <div className="col-xs-4 col-md-1">sc964</div>
                <div className="col-xs-4 col-md-1">451<br/>554</div>
                <div className="col-xs-36 col-md-6">{t("par22")}</div>
              </div>
              <div className="border-horizontal"></div>
              <div className="row">
                <div className="col-xs-4 col-md-1">sc975 sc979 sc982</div>
                <div className="col-xs-4 col-md-1">451<br/>554</div>
                <div className="col-xs-36 col-md-6">
                  <Trans i18nKey="par23" t={t}>
                    Your E-mail was rejected due to suspicious activity. If you
                    find this to be an error, please contact our support via <ContactFormLink/>.
                  </Trans>
                </div>
              </div>
              <div className="border-horizontal"></div>
              <div className="row">
                <div className="col-xs-4 col-md-1">sc965 sc980</div>
                <div className="col-xs-4 col-md-1">451</div>
                <div className="col-xs-36 col-md-6">{t("par24")}</div>
              </div>
              <div className="border-horizontal"></div>
              <div className="row">
                <div className="col-xs-4 col-md-1">sc967</div>
                <div className="col-xs-4 col-md-1">554</div>
                <div className="col-xs-36 col-md-6">{t("par25")}</div>
              </div>
              <div className="border-horizontal"></div>
              <div className="row">
                <div className="col-xs-4 col-md-1">sc968</div>
                <div className="col-xs-4 col-md-1">554</div>
                <div className="col-xs-36 col-md-6">
                  <Trans i18nKey="par26" t={t}>
                    Your E-Mail was classified as spam. If you find this to be
                    an error, please contact our support via <ContactFormLink/>.
                  </Trans>
                </div>
              </div>
              <div className="border-horizontal"></div>
              <div className="row">
                <div className="col-xs-4 col-md-1">sc969</div>
                <div className="col-xs-4 col-md-1">554</div>
                <div className="col-xs-36 col-md-6">
                  <Trans i18nKey="par27" t={t}>
                    Your E-Mail was rejected because your sending source exceeded
                    the allowed threshold for content classified as spam. If you
                    believe this is an error, please contact our support via the <ContactFormLink/>.
                  </Trans>
                </div>
              </div>
              <div className="border-horizontal"></div>
              <div className="row">
                <div className="col-xs-4 col-md-1">sc971</div>
                <div className="col-xs-4 col-md-1">554</div>
                <div className="col-xs-36 col-md-6">{t("par28")}</div>
              </div>
              <div className="border-horizontal"></div>
              <div className="row">
                <div className="col-xs-4 col-md-1">sc972</div>
                <div className="col-xs-4 col-md-1">451</div>
                <div className="col-xs-36 col-md-6">{t("par29")}</div>
              </div>
              <div className="border-horizontal"></div>
              <div className="row">
                <div className="col-xs-4 col-md-1">sc945</div>
                <div className="col-xs-4 col-md-1">451</div>
                <div className="col-xs-36 col-md-6">{t("par30")}</div>
              </div>
              <div className="border-horizontal"></div>
              <div className="row">
                <div className="col-xs-4 col-md-1">sc982</div>
                <div className="col-xs-4 col-md-1">554</div>
                <div className="col-xs-36 col-md-6">
                  <Trans i18nKey="par31" t={t}>
                    Your E-Mail was classified as a virus. If you find this to be
                    an error, please contact our support via <ContactFormLink/>.
                  </Trans>
                </div>
              </div>
              <div className="border-horizontal"></div>
              <div className="row">
                <div className="col-xs-4 col-md-1">sc42</div>
                <div className="col-xs-4 col-md-1">451<br/>554</div>
                <div className="col-xs-36 col-md-6">
                  <Trans i18nKey="par32" t={t}>
                    The transmission of your message was rejected for internal policy
                    reasons. If you consider this to be an error, please contact our
                    support via <ContactFormLink/>.
                  </Trans>
                </div>
              </div>
              <div className="border-horizontal"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

class ContactFormLink extends React.Component {
  render() {
    return (
      <a href={i18n.t("common:linkContactForm")}>
        {i18n.t("common:contactForm")}
      </a>
    );
  }
}

function AbusixLink() {
  return (
      <a href={"https://lookup.abusix.com/search"}>
        {"https://lookup.abusix.com/search"}
      </a>
  );
}

function CloudMarkLink() {
  return (
      <a href={"https://csi.cloudmark.com/reset-request"}>
        {"https://csi.cloudmark.com/reset-request"}
      </a>
  );
}

function scrollToOut() {
  const element = document.getElementById("outbound-ip-addresses");
  element.scrollIntoView();
}

function scrollToError() {
  const element = document.getElementById("error-codes");
  element.scrollIntoView();
}
